import { Button } from '@mui/material';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { subjectsApi } from 'api/subjects-api';
import { modalStyles } from 'shared/styles';

interface Props {
  isOpen: boolean;
  close: () => void;
  id?: string;
  onReset: () => void;
}

export const RemoveOptionModal = ({ isOpen, close, id, onReset }: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const removeOption = async () => {
    setIsLoading(true);

    try {
      id && (await subjectsApi.removeSubject(id));
    } catch (error) {
      console.log(error);
      toast.error(t('Something went wrong. Try again!'));
    }

    onReset();
    setIsLoading(false);
    close();
    toast.success(t('Successfully removed!'));
  };

  const isSubmitButtonDisabled = isLoading;

  return (
    <Modal isOpen={isOpen} onRequestClose={close} style={modalStyles} closeTimeoutMS={300}>
      <h2>Remove option</h2>

      <div className="flex flex-col gap-4">
        <Button className="btn clear-filter with-icon" onClick={removeOption} disabled={isSubmitButtonDisabled}>
          Remove
        </Button>
      </div>
    </Modal>
  );
};
